import React, { useState, useEffect } from 'react';
import { useHistory, Route, Switch, Link ,useLocation} from 'react-router-dom';
import { Menu, Select, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import $ from 'jquery';
import Page404 from '../../system/404/404';
import './main.css'

import Default from '../default/default';
import Login from '../login/login';
import SysParam from '../sysParam/sysParam';
import SysParamSegment from '../sysParamSegment/sysParamSegment';
import SysFunc from '../sysFunc/sysFunc';
import SysRole from '../sysRole/sysRole';
import SysUser from '../sysUser/sysUser';
import UserFavorite from '../sysUserFavorite/sysUserFavorite';
import WilPwdManage from '../wilPwdManage/wilPwdManage';
import ChangeUserPassword from '../changeUserPassword/changeUserPassword';
import OperationLogManage from '../operationLogManage/operationLogManage';
import TimedTask from '../timedTask/timedTask';
import SchedulingLog from '../schedulingLog/schedulingLog';
import PictureScrollManage from '../pictureScrollManage/pictureScrollManage';
import NewsManagement from '../newsManagement/newsManagement';
import ApiLogging from '../apiLogging/apiLogging';
import fanhui from '../../public/img/fanhui.png';
import WilProgrammeSetup from '../../pages/wilProgrammeSetup/wilProgrammeSetup';
import EplatformResourcePageManagement from '../../pages/eplatformResourcePageManagement/eplatformResourcePageManagement';
import Dashboard from '../../pages/dashboard/dashboard';
import MessageTemplate from '../messageTemplate/messageTemplate';

import UserAccountManagementStudent from '../../pages/userAccountManagementStudent/userAccountManagementStudent';
import ProgrammeWpaTemplate from '../../pages/programmeWpaTemplate/programmeWpaTemplate';
import UserAccountManagementAcademicStaff from '../../pages/userAccountManagementAcademicStaff/userAccountManagementAcademicStaff';
import IndustrialPartner from '../../pages/industrialPartner/industrialPartner';
import JobManagement from '../../pages/jobManagement/jobManagement';
import JobApplicationRecord from '../../pages/jobApplicationRecord/jobApplicationRecord';
import UserAccountManagementAdminList from '../../pages/userAccountManagementAdminList/userAccountManagementAdminList';
import Department from '../../pages/department/department';
import Module from '../../pages/module/module';
import CohortModule from '../../pages/cohortModule/cohortModule';

import CohortSetup from '../../pages/cohortSetup/cohortSetup';
import Cohort from '../../pages/cohort/cohort';
import CohortProg from '../../pages/cohortProg/cohortProg';

import Programme from '../../pages/programme/programme';
import WilProgramme from '../../pages/wilProgramme/wilProgramme';
import Student from '../../pages/student/student';
import HouseKeeping from '../../pages/houseKeeping/houseKeeping';
import StudentReport from '../../pages/studentReport/studentReport';
import AcademicStaffReport from '../../pages/academicStaffReport/academicStaffReport';
import IndustryPartnerReport from '../../pages/industrialPartnerReport/industrialPartnerReport';

import logoImg from '../../public/img/logo.jpg';
import JobManagementReport from '../../pages/jobManagementReport/jobManagementReport';
import JobApplicationReport from '../../pages/jobApplicationReport/jobApplicationReport';
import StudentRecord from '../../pages/studentRecord/studentRecord';
import UserAccountManagementAcademicStaffReport from '../../pages/userAccountManagementAcademicStaffReport/userAccountManagementAcademicStaffReport';
import IndustrialPartnerRecord from '../../pages/industrialPartnerRecord/industrialPartnerRecord';
import RestoreHouseKeeping from '../../pages/restoreHouseKeeping/restoreHouseKeeping';
import WilProgrammeSetupReport from '../../pages/wilProgrammeSetupReport/wilProgrammeSetupReport';
import LiteAdmin from '../liteAdmin/liteAdmin';
import StudentModule from '../../pages/studentModule/studentModule';
import FormSetup from '../../pages/formSetup/formSetup';
import TestTurnitin from '../../pages/testTurnitin/testTurnitin';
import WpaApplRecord from '../../pages/wpaApplRecord/wpaApplRecord';
import StudentModuleRecord from '../../pages/studentModuleRecord/studentModuleRecord';
import StudentModuleAssignRecord from '../../pages/studentModuleAssignRecord/studentModuleAssignRecord';
import KeyDocumentRecord from '../../pages/keyDocumentRecord/keyDocumentRecord';
import SurveyTemplate from '../../pages/surveyTemplate/surveyTemplate';
import Survey from '../../pages/survey/survey';
import SurveyRecordReport from '../../pages/surveyRecordReport/surveyRecordReport';
import StudentModuleRecordReport from '../../pages/studentModuleRecordReport/studentModuleRecordReport';
import WpaApplRecordReport from '../../pages/wpaApplRecordReport/wpaApplRecordReport';

const SubMenu = Menu.SubMenu;
const { Option } = Select;

const Main = (props) => {

    const history = useHistory();

    const [collapsed, setCollapsed] = useState(false);
    const [sysUserRoleList, setSysUserRoleList] = useState([]);
    const [defaultUserRoleId, setDefaultUserRoleId] = useState("");
    const [menuList, setMenuList] = useState([]);
    const [selectList, setSelectList] = useState([]);
    const [openKeys, setOpenKeys] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const [innerWidthFlag, setInnerWidthFlag] = useState(true);
    const [selectedOpenKeys,setSelectedOpenKeys] = useState([]);
    const location = useLocation();

    useEffect(() => {
        if (Config.equipmentInfo.type === 'phone') {
            setCollapsed(true);
            setOpenKeys([]);
        }
        checkLogin();
        setSelectedOpenKeys([])
    }, []);

    useEffect(() => {
        if(location.model){
               // 更新选中的菜单项
            const pathname = location.pathname;
            let  selectedOpenKey=[]
            selectedOpenKey= JSON.parse(JSON.stringify(selectedOpenKeys))
            menuList.map((item=>{
                item.children.map((items=>{
                    if(items.funcUrl==pathname.slice(6)){
                        Config.funcInfo =items
                        Config.header['func'] = Config.funcInfo?.funcCodeEncrypt;
                        setSelectList([items.funcCode+items.parentId])
                        selectedOpenKey.push(item.funcCode)
                        setSelectedOpenKeys(selectedOpenKey)
                    }
                }))
            }))
        }
      }, [location]);

    useEffect(() => {
        const updateSize = () => {
            setTimeout(() => {
                toggleCollapseds()
            }, 100); 
        };
        updateSize();
        window.addEventListener("resize", updateSize);
    }, [window.innerWidth])

    const toggleCollapseds = () => {
        if(!innerWidthFlag){
            setInnerWidthFlag(true)
        }else{ 
            setInnerWidthFlag(true)
            var left = document.getElementById('leftMenu');
            var right = document.getElementById('rightMain');
            var screenWidth = window.innerWidth;
            if (left && right) {
                if (screenWidth < 1000) {
                    if (left.getAttribute('class') != "hideLeftMenu") {
                        left.setAttribute("class", "hideLeftMenu");
                        setCollapsed(true)
                    }
                } 
            }
        }
    }

    const checkLogin = () => {
        if (Config.userInfo.userId) {
            searchSysUserRoleList();
            searchSysUserProg();
            searchCohortYear();
        } else {
            if (Base.isEmpty(Config.header.authorization)) {
                Config.header.authorization = localStorage.getItem('wilBackAccessToken');
            }
            let token = localStorage.getItem('wilBackRefreshToken');
            if (token) {
                $.ajax({
                    url: Config.apiServer + "admin/login/checkToken",
                    type: "POST",
                    data: JSON.stringify(token),
                    async: false,
                    headers: Config.header,
                    contentType: "application/json; charset=utf-8",
                    dataType: 'json',
                    success: (data) => {
                        if ("SUCCESS" === data.msg && data.object.userInfo.userType != 'STUDENT' && data.object.userInfo.userType != 'ACADEMIC' && data.object.userInfo.userType != 'PARTNER') {
                            Config.userInfo = data.object.userInfo;
                            Config.header.authorization = data.object.accessToken + '';
                            Config.sasToken = data.object.sasToken;
                            localStorage.setItem('wilBackAccessToken', data.object.accessToken);
                            localStorage.setItem('wilBackRefreshToken', data.object.refreshToken);
                            searchSysUserRoleList();
                            searchSysUserProg();
                            searchCohortYear();
                        } else {
                            Base.removeAllLocalStorage();
                            if (window.location.href.lastIndexOf("/login") === -1) {
                                history.push("/login");
                            }
                        }
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                    }
                });
            } else {
                history.push("/login");
            }
        }
    }

    const searchCohortYear = () => {
        $.ajax({
            url: Config.apiServer + "admin/back/cohort/searchCohortYear",
            type: "POST",
            async: false,
            headers: Config.header,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: (data) => {
                if ("SUCCESS" === data.msg) {
                    Config.cohort = data?.object
                } else {
                    console.log("error", data.msg);
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
            }
        })
    }

    const searchSysUserRoleList = () => {
        Base.callBackApi("user/searchDefaultSysUserRole").then((data) => {
            if ("SUCCESS" === data.msg) {
                let roles = data.object ?? [];
                if (roles) {
                    Config.userInfo.role = roles[0];
                    Config.header['x-auth-token'] = Config.userInfo.role?.roleCodeEncrypt;
                }
                setSysUserRoleList(JSON.parse(JSON.stringify(roles)));
                setDefaultUserRoleId(Config.userInfo?.role?.userRoleId);
                if (!!roles && roles.length > 0) {
                    searchMenu(roles[0]);
                }
            } else {
                console.log("error", data.msg);
            }
        }).catch(err => { }).finally(() => { });
    }

    const searchSysUserProg = () => {
        Base.callBackApi("user/searchSysUserProg", Config.userInfo.userId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let programmeList = data.object ?? [];
                Config.userInfo.progCodeList = programmeList.map(item =>
                    item.progCode
                )
            } else {
                console.log("error", data.msg);
            }
        }).catch(err => { }).finally(() => { });
    }

    const searchMenu = (role) => {
        Base.callBackApi("func/leftMenuSearch", role).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                let newList = [];
                let openKeys = [];
                for (let item of list) {
                    item.children = []
                    for (let iterator of list) {
                        if (item.funcId === iterator.parentId) {
                            item.children.push(iterator)
                        }
                    }
                    item.children.sort(function (a, b) {
                        return a.dispSeq - b.dispSeq;
                    });
                    if (item.type === "MENU") {
                        newList.push(item)
                    }
                }
                for (let item2 of newList) {//获取需要展开的模块id
                    if (Base.isNotEmpty(item2.children)) {
                        openKeys.push(item2.funcCode);
                        for (let subItem of item2.children) {
                            if (subItem.children.length > 0) {
                                openKeys.push(subItem.funcCode);
                            }
                        }
                    }
                }
                localStorage.setItem('menuList', JSON.stringify(newList));
                localStorage.setItem('openKeys', JSON.stringify(openKeys));
                Config.openKeys = openKeys;

                let menuList = JSON.parse(localStorage.getItem("menuList"));
                var urlInfo = window.location.href.split("/");
                let selectList = []
                for (let iterator of menuList) {
                    if (Base.isNotEmpty(iterator.children)) {
                        for (let item of iterator.children) {
                            if (item.funcUrl === urlInfo[urlInfo.length - 1]) {
                                selectList = [item.funcCode + item.parentId]
                            } else if (item.funcUrl + "?sysUserFavorite" === urlInfo[urlInfo.length - 1] && iterator.funcCode === "MY_FAVORITE") {//"我的最爱"menu下模块刷新跳到其他menu问题
                                selectList = [item.funcCode + item.parentId]
                            }
                        }
                    }
                }

                let menuListUntreated = list;//没有分层级的menuList
                let href = window.location.href;
                let funcUrl = href.slice(parseInt(href.lastIndexOf("main/")) + 5, href.length);
                let menuUntreated = menuListUntreated.filter((obj) => {
                    return obj.funcUrl == funcUrl;
                })
                if (Base.isNotEmpty(menuUntreated)) {
                    Config.funcInfo = menuUntreated[0];
                    Config.header['func'] = Config.funcInfo?.funcCodeEncrypt;
                }

                setMenuList(JSON.parse(JSON.stringify(menuList)));
                setSelectList(JSON.parse(JSON.stringify(selectList)));
                setIsShow(true);
            } else {
                console.log(data.msg)
            }
        }).catch(err => {
            console.log(err)
            console.log("接口调用失败，请检查服务器是否启动")
        });
    }

    //缩放menu列
    const toggleCollapsed = () => {
        var left = document.getElementById('leftMenu');
        var right = document.getElementById('rightMain');
        if (left.getAttribute('class') === "hideLeftMenu") {
            left.setAttribute("class", "showLeftMenu");
            right.setAttribute("class", "showMenu");
        } else {
            left.setAttribute("class", "hideLeftMenu");
        }
        setCollapsed(!collapsed);
    }

    //选中menu
    const select = (item) => {
        setSelectList(JSON.parse(JSON.stringify(item.selectedKeys)));
    }

    const toChangePassword = () => {
        history.push('/main/changeUserPassword');
    }

    // 校验权限(判断url输入的menu是否存在，不存在就跳到default页面)
    const authorization = (component) => {
        let existence = false;
        let menuList = JSON.parse(localStorage.getItem("menuList"));
        var urlInfo = window.location.href.split("/");
        if (Base.isNotEmpty(menuList)) {
            for (let iterator of menuList) {
                if (Base.isNotEmpty(iterator.children)) {
                    for (let item of iterator.children) {
                        if (Base.isNotEmpty(item.children)) {
                            for (let sbuItem of iterator.children) {
                                if (sbuItem.funcUrl === urlInfo[urlInfo.length - 1] || sbuItem.funcUrl + "?userFavorite" === urlInfo[urlInfo.length - 1]) {
                                    existence = true;
                                    Config.funcInfo = sbuItem;
                                    Config.header['func'] = Config.funcInfo?.funcCodeEncrypt;
                                    break;
                                }
                            }
                        } else {
                            if (item.funcUrl === urlInfo[urlInfo.length - 1] || item.funcUrl + "?userFavorite" === urlInfo[urlInfo.length - 1]) {
                                existence = true;
                                Config.funcInfo = item;
                                Config.header['func'] = Config.funcInfo?.funcCodeEncrypt;
                                break;
                            }
                        }
                    }
                }
            }
        } else {
            history.push('/login');
            return <Login />;
        }
        if (!existence) {
            Config.funcInfo = {};
            Config.header['func'] = Config.funcInfo?.funcCodeEncrypt;
            history.push('/main/default');
            return <Default />;
        }
        return component;
    }

    /**左侧二三级选项卡切换*/
    const twoMenu = (subItem) => {
        Config.funcInfo = subItem;
        Config.header['func'] = Config.funcInfo?.funcCodeEncrypt;
    }

    /** 切换组别 */
    const roleChange = (e) => {
        let role = sysUserRoleList.find(item => item.userRoleId === e);
        Config.userInfo.role = role;
        Config.header['x-auth-token'] = Config.userInfo.role?.roleCodeEncrypt;
        setDefaultUserRoleId(e);
        addRoleLoginRecord(role)
        searchMenu(role);//重新查询menu
        history.push('/main/default');
    }

    const addRoleLoginRecord = (roleModel) => {
        Base.callBackApi("sysUserLoginRecord/insertLoginRecord", roleModel).then((data) => {
            console.log("error",data.msg);
        }).catch(err => { }).finally(() => { });
    }

    // 登出方法,以前的版本，请求后台接口清除当前yoghurt信息
    const logout = () => {
        fetch(Config.apiServer + "admin/login/lgout", {
            method: 'POST',
            body: JSON.stringify(Config.userInfo),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                Config.userInfo = {};
                Config.header.authorization = '';
                Base.removeAllLocalStorage();
                // history.push('/login');
                window.location.replace(Config.logoutUri);
            } else {
                console.log(data.msg);
            }
        }).catch(err => { }).finally(() => {});
    }

    const downloadFile = () => {
        if (!Base.stopClick()){
            return;
        }
        let model = {
            "segment": 'STORAGE_PATH',
            "code": 'WIL_ADMIN_PORTAL_PATH',
        }
        Base.callBackApi("param/searchSysParamByCode", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                Base.downloadFile(Config.imgServer + model.parmValue1 + '?' + Config.sasToken, model.parmValue2)
            } else {
                console.log(data.msg);
            }
        }).catch(err => { })
    }

    const onOpenChange=(openKeys)=>{
        setSelectedOpenKeys(openKeys)
    }

    return (
        <div>
            {isShow ? <>
                <div id="main">
                    {/* 左边菜单区域 */}
                    <div id="leftMenu" className={Config.equipmentInfo.type === 'phone' ? "hideLeftMenu" : "showLeftMenu"}>
                        <div className="head">
                            {!collapsed &&
                                <img src={logoImg} className='logo' />
                            }
                            {/* {!collapsed &&
                                <span className="headTitle">{Config.backLang == 'SC' ? 'WIL系统' : (Config.backLang == 'TC' ? 'WIL系統' : 'WIL System')}</span>
                            } */}
                            <MenuOutlined className='headIcons' onClick={toggleCollapsed} />
                        </div>
                        <Menu
                            defaultOpenKeys={openKeys}
                            selectedKeys={selectList}
                            openKeys={selectedOpenKeys}
                            onOpenChange={onOpenChange}
                            onSelect={(e) => select(e)}
                            mode="inline"
                            theme="dark"
                            style={{ "backgroundColor": "#000000" }}
                            inlineIndent={5}
                            inlineCollapsed={collapsed}>
                            {menuList.map((item) =>
                                <SubMenu
                                    key={item.funcCode}
                                    style={{ "backgroundColor": "#000000" }}
                                    title={
                                        <div className='funcRow'>
                                            <div className="funcIcon">
                                                {item.image && <img className="funcImg" src={Config.funcImg + item.image + '?' + Config.sasToken}></img>}
                                            </div>
                                            {!collapsed && <div className="fontWtIcon">{Config.backLang == 'SC' ? item.funcName : (Config.backLang == 'TC' ? item.funcNameTc : item.funcNameEn)}</div>}
                                        </div>
                                    }
                                >
                                    {item.children.map((subItem) => (
                                        subItem.children.length > 0 ?
                                            <SubMenu
                                                key={subItem.funcCode}
                                                title={
                                                    <div className='funcRowTwo'>
                                                        <div className="funcIcon">
                                                            {subItem.image && <img className="funcImg" src={Config.funcImg + subItem.image + '?' + Config.sasToken}></img>}
                                                        </div>
                                                        {!collapsed && <div className="fontWtIcon">{Config.backLang == 'SC' ? subItem.funcName : (Config.backLang == 'TC' ? subItem.funcNameTc : subItem.funcNameEn)}</div>}
                                                    </div>
                                                }
                                            >
                                                {subItem.children.map((charItem) =>
                                                    <Menu.Item key={charItem.funcCode + charItem.parentId} onClick={() => { twoMenu(charItem) }}>
                                                        <div className="fontWtTwo">{Config.backLang == 'SC' ? subItem.funcName : (Config.backLang == 'TC' ? subItem.funcNameTc : subItem.funcNameEn)}</div>
                                                        <Link to={"/main/" + charItem.funcUrl} replace></Link>
                                                        {/* <Link to={"/main/" + charItem.funcUrl} replace></Link> */}
                                                    </Menu.Item>
                                                )}
                                            </SubMenu>
                                            :
                                            <Menu.Item key={subItem.funcCode + subItem.parentId} onClick={() => { twoMenu(subItem) }}>
                                                <div className="fontWt">{Config.backLang == 'SC' ? subItem.funcName : (Config.backLang == 'TC' ? subItem.funcNameTc : subItem.funcNameEn)}</div>
                                                <Link to={"/main/" + subItem.funcUrl + (item.funcCode == "MY_FAVORITE" ? "?userFavorite" : '')} replace></Link>
                                            </Menu.Item>
                                    ))}
                                </SubMenu>
                            )}
                        </Menu>
                    </div>
                    {/* 右边内容区域 */}
                    <div id="rightMain" className={collapsed ? "hideRightWidth" : "showRightWidth"}>
                        <div className="head">
                            <div className='logoName'>Technological and Higher Education Institute of Hong Kong</div>
                            <div className='userInfoBox'>
                                <div className='headCol'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={downloadFile}>Manual File</Button>
                                </div>
                                <div className='headCol'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={toChangePassword}>Change Password</Button>
                                </div>
                                {Config.backLang == 'SC' ? '用户' : (Config.backLang == 'TC' ? '用戶' : 'User')}:&nbsp;
                                <div className="headCol" title={(Config.backLang == 'SC' ? '用户:' : (Config.backLang == 'TC' ? '用戶:' : 'User:')) + (Config.userInfo ? (Config.userInfo.name ?? Config.userInfo.userCode) : "")}>{Config.userInfo ? (Config.userInfo.name ?? Config.userInfo.userCode) : ""}</div>
                                {Config.backLang == 'SC' ? '角色' : (Config.backLang == 'TC' ? '角色' : 'Role')}：&nbsp;&nbsp;
                                <div className='headCol'>
                                    <div>
                                        <Select style={{ width: "100%", "borderRadius": "10px" }} className='sysSelect' value={defaultUserRoleId}
                                            onChange={(e) => roleChange(e)}>
                                            {sysUserRoleList.map((item) => <Option key={item.userRoleId} value={item.userRoleId} title={Config.backLang == 'SC' ? '角色:' : (Config.backLang == 'TC' ? '角色:' : 'Role')}>{item.roleName}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className="headCols" onClick={logout}>
                                    <img src={fanhui} title={Config.backLang == 'SC' ? '登出' : (Config.backLang == 'TC' ? '登出' : 'Log Out')} />
                                </div>
                            </div>
                        </div>
                        <div className='line'></div>
                        <Switch>
                            <Route path="/main/" exact component={Default} />
                            <Route path="/main/default" exact component={Default} />
                            <Route path="/main/changeUserPassword" exact component={ChangeUserPassword} />

                            {/* 系統管理 */}
                            <Route path="/main/sysParam" exact render={props => authorization(<SysParam {...props} />)} />
                            <Route path="/main/sysParamSegment" exact render={props => authorization(<SysParamSegment {...props} />)} />
                            <Route path="/main/sysFunc" exact render={props => authorization(<SysFunc searchMenu={searchMenu} {...props} />)} />{/* 通过searchMenu方法刷新menu */}
                            <Route path="/main/sysRole" exact render={props => authorization(<SysRole searchMenu={searchMenu} {...props} />)} />
                            <Route path="/main/sysUser" exact render={props => authorization(<SysUser {...props} />)} />
                            <Route path="/main/sysUserFavorite" exact render={props => authorization(<UserFavorite searchMenu={searchMenu} menuList={menuList} {...props} />)} />
                            <Route path="/main/wilPwdManage" exact render={props => authorization(<WilPwdManage searchMenu={searchMenu} {...props} />)} />
                            <Route path="/main/operationLogManage" exact render={props => authorization(<OperationLogManage {...props} />)} />
                            <Route path="/main/timedTask" exact render={props => authorization(<TimedTask {...props} />)} />
                            <Route path="/main/schedulingLog" exact render={props => authorization(<SchedulingLog {...props} />)} />
                            <Route path="/main/pictureScrollManage" exact render={props => authorization(<PictureScrollManage {...props} />)} />
                            <Route path="/main/newsManagement" exact render={props => authorization(<NewsManagement {...props} />)} />
                            <Route path="/main/apiLogging" exact render={props => authorization(<ApiLogging {...props} />)} />
                            <Route path="/main/messageTemplate" exact render={props => authorization(<MessageTemplate {...props} />)} />
                            <Route path="/main/wilProgrammeSetup" exact render={props => authorization(<WilProgrammeSetup {...props} />)} />
                            <Route path="/main/eplatformResourcePageManagement" exact render={props => authorization(<EplatformResourcePageManagement {...props} />)} />
                            <Route path="/main/dashboard" exact render={props => authorization(<Dashboard {...props} />)} />
                            <Route path="/main/userAccountManagementStudent" exact render={props => authorization(<UserAccountManagementStudent {...props} />)} />
                            <Route path="/main/userAccountManagementAcademicStaff" exact render={props => authorization(<UserAccountManagementAcademicStaff {...props} />)} />
                            <Route path="/main/industrialPartner" exact render={props => authorization(<IndustrialPartner {...props} />)} />
                            <Route path="/main/jobManagement" exact render={props => authorization(<JobManagement {...props} />)} />
                            <Route path="/main/jobApplicationRecord" exact render={props => authorization(<JobApplicationRecord {...props} />)} />

                            <Route path="/main/programmeWpaTemplate" exact render={props => authorization(<ProgrammeWpaTemplate {...props} />)} />
                            <Route path="/main/userAccountManagementAdminList" exact render={props => authorization(<UserAccountManagementAdminList {...props} />)} />
                            <Route path="/main/department" exact render={props => authorization(<Department {...props} />)} /> 
                            <Route path="/main/module" exact render={props => authorization(<Module {...props} />)} />
                            <Route path="/main/cohortModule" exact render={props => authorization(<CohortModule {...props} />)} />

                            <Route path="/main/cohortSetup" exact render={props => authorization(<CohortSetup {...props} />)} />
                            <Route path="/main/programme" exact render={props => authorization(<Programme {...props} />)} />
                            <Route path="/main/cohort" exact render={props => authorization(<Cohort {...props} />)} />
                            <Route path="/main/cohortProg" exact render={props => authorization(<CohortProg {...props} />)} />
                            <Route path="/main/liteAdmin" exact render={props => authorization(<LiteAdmin {...props} />)} />

                            <Route path="/main/wilProgramme" exact render={props => authorization(<WilProgramme {...props} />)} />
                            <Route path="/main/student" exact render={props => authorization(<Student {...props} />)} />
                            <Route path="/main/houseKeeping" exact render={props => authorization(<HouseKeeping {...props} />)} />
                            <Route path="/main/archivedRecord" exact render={props => authorization(<RestoreHouseKeeping {...props} />)} />
                            <Route path="/main/studentReport" exact render={props => authorization(<StudentReport {...props} />)} />
                            <Route path="/main/academicReport" exact render={props => authorization(<AcademicStaffReport {...props} />)} />
                            <Route path="/main/industryPartnerReport" exact render={props => authorization(<IndustryPartnerReport {...props} />)} />
                            <Route path="/main/jobPostingReport" exact render={props => authorization(<JobManagementReport {...props} />)} />
                            <Route path="/main/jobApplicationReport" exact render={props => authorization(<JobApplicationReport {...props} />)} />
                            <Route path="/main/wilProgrammeSetupReport" exact render={props => authorization(<WilProgrammeSetupReport {...props} />)} />
                            <Route path="/main/studentRecord" exact render={props => authorization(<StudentRecord {...props} />)} />
                            <Route path="/main/academicRecord" exact render={props => authorization(<UserAccountManagementAcademicStaffReport {...props} />)} />
                            <Route path="/main/partnerRecord" exact render={props => authorization(<IndustrialPartnerRecord {...props} />)} />
                            <Route path="/main/studentModule" exact render={props => authorization(<StudentModule {...props} />)} />
                            <Route path="/main/formSetup" exact render={props => authorization(<FormSetup {...props} />)} />
                            <Route path="/main/testTurnitin" exact render={props => authorization(<TestTurnitin {...props} />)} />
                            <Route path="/main/wpaApplRecord" exact render={props => authorization(<WpaApplRecord {...props} />)} />
                            <Route path="/main/studentModuleRecord" exact render={props => authorization(<StudentModuleRecord {...props} />)} />
                            <Route path="/main/studentModuleAssignRecord" exact render={props => authorization(<StudentModuleAssignRecord {...props} />)} />
                            <Route path="/main/keyDocumentRecord" exact render={props => authorization(<KeyDocumentRecord {...props} />)} />
                            <Route path="/main/surveyTemplate" exact render={props => authorization(<SurveyTemplate {...props} />)} />
                            <Route path="/main/survey" exact render={props => authorization(<Survey {...props} />)} />
                            <Route path="/main/surveyRecordReport" exact render={props => authorization(<SurveyRecordReport {...props} />)} />
                            <Route path="/main/studentModuleRecordReport" exact render={props => authorization(<StudentModuleRecordReport {...props} />)} />
                            <Route path="/main/wpaApplRecordReport" exact render={props => authorization(<WpaApplRecordReport {...props} />)} />
                            
                            <Route exact component={Page404} />
                        </Switch>
                    </div>
                </div>
            </> : null}
        </div>
    )
}

export default Main;